import { render, staticRenderFns } from "./keywords-word-cell.html?vue&type=template&id=ac580ed0&scoped=true&"
import script from "./keywords-word-cell.js?vue&type=script&lang=js&"
export * from "./keywords-word-cell.js?vue&type=script&lang=js&"
import style0 from "./keywords-word-cell.scss?vue&type=style&index=0&id=ac580ed0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac580ed0",
  null
  
)

export default component.exports